import { motion } from "framer-motion";
import { Link } from "wouter";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

export default function MobileApp() {
  const platforms = [
    {
      name: "iOS",
      icon: "fab fa-apple",
      description: "High-performance native iOS apps using Swift & Objective."
    },
    {
      name: "Android",
      icon: "fab fa-android",
      description: "Robust Android applications built with Kotlin & Java."
    },
    {
      name: "React Native",
      icon: "fab fa-react",
      description: "Cost-effective cross-platform apps with React Native."
    },
    {
      name: "Flutter",
      icon: "fas fa-mobile-alt",
      description: "Beautiful & fast apps using Google’s Flutter framework."
    }
  ];

  return (
    <div
      className="min-h-screen overflow-x-hidden bg-white"
      style={{ fontFamily: "'Roboto', sans-serif" }}
    >
      <Navigation />

      {/* ================= HERO (DARK PREMIUM) ================= */}
      <section className="relative flex items-center justify-center overflow-hidden bg-[#040814] text-white pt-28 pb-8">
        {/* Background */}
        <div className="absolute inset-0">
        </div>

        <div className="container mx-auto px-6 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            className="text-center max-w-4xl mx-auto"
          >
            <div className="flex items-center justify-center gap-3 mb-6 text-sm text-slate-300">
              <Link href="/service" className="hover:text-white transition">
                Services
              </Link>
              <i className="fas fa-chevron-right text-xs" />
              <span className="text-slate-400">Mobile App Development</span>
            </div>

            <h1 className="text-4xl md:text-5xl font-black leading-tight mt-5 mb-6">
              We Build Next-Gen <br />
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-cyan-300">
                 Mobile Applications
              </span>
            </h1>

            <p className="text-lg md:text-xl text-slate-300 max-w-3xl mx-auto mb-10">
              Variable Soft is a leading mobile app development company delivering
              scalable, secure and user-centric mobile solutions across platforms.
            </p>
          </motion.div>
        </div>
      </section>

      {/* ================= PLATFORMS (LIGHT CLEAN) ================= */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false }}
            transition={{ duration: 0.7 }}
            className="text-center mb-20"
          >
            <h2 className="text-4xl md:text-5xl font-black text-slate-900 mb-5">
              Development <span className="text-blue-600">Platforms</span>
            </h2>
            <p className="text-lg text-slate-600 max-w-3xl mx-auto">
              We deliver powerful mobile apps across all major platforms using
              modern technologies and best practices.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            {platforms.map((platform, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false }}
                transition={{ duration: 0.6, delay: index * 0.08 }}
                className="group bg-white rounded-3xl p-8 border border-slate-100 shadow-xl hover:shadow-2xl transition-all text-center"
              >
                <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-gradient-to-r from-blue-500 to-cyan-400 flex items-center justify-center group-hover:scale-110 transition">
                  <i className={`${platform.icon} text-white text-2xl`} />
                </div>

                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  {platform.name}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {platform.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
